import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {

    statusPredictions: [],
    statusPredictionsExpire: null,

    widgets: [],

    panelSizeStats: [],
    panelSizeStatsExpire: null,

    projectActivityStats: [],
    projectActivityStatsExpire: null,

    projectActivityStatsForLastHour: [],
    projectActivityStatsForLastHourExpire: null,
}

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

